import React, { useContext } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import FlowstationProductionTrendStore from "../store/FlowstationProductionTrendStore";
import { createContext } from "react";
import moment from "moment";
import { Skeleton } from "antd";

import { Observer } from "mobx-react-lite";
const flowstationProductionTrendStoreCtx = createContext(
  FlowstationProductionTrendStore
);
export const CummulativeTrendChart = () => {
  const flowstationProductionTrendStore = useContext(
    flowstationProductionTrendStoreCtx
  );
  return (
    <Observer>
      {() => {
        const plotData = flowstationProductionTrendStore.plotData || [];
        const getSeriesData = (field) =>
          plotData.map((point) => {
            const value = Number(point?.[field]);
            return Number.isFinite(value) ? value : null;
          });

        return flowstationProductionTrendStore.isIniatilizing ? (
          <>
            <div style={{ padding: "15px" }}>
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </div>
          </>
        ) : (
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              chart: {
                zoomType: "xy",
              },
              credits: {
                enabled: true,
                text: "source: SPARS",
                href: "mailto:projects@cybersprintitsolutions.com",
              },
              title: {
                text: `${flowstationProductionTrendStore.selectedFlowstation.flowsationName} Cummulative Production `,
                align: "center",
              },
              subtitle: {
                text: "",
              },
              xAxis: [
                {
                  categories: plotData.map((point) =>
                    point?.productionDate
                      ? moment(point.productionDate).format("MM-Y")
                      : ""
                  ),
                  crosshair: true,
                },
              ],
              yAxis: [
                {
                  // Tertiary yAxis
                  gridLineWidth: 0,
                  min: 0,
                  title: {
                    text: "Gas Cummulatives  (Mscf)",
                  },
                  lineWidth: 1,
                  minorGridLineWidth: 1,
                  minorTickInterval: "auto",
                  minorTickWidth: 1,
                  tickPosition: "outside",
                  tickWidth: 2,
                },
                {
                  // Secondary yAxis
                  gridLineWidth: 0,
                  title: {
                    text: " Oil Cummulatives (stb)",
                  },
                  lineWidth: 1,
                  minorGridLineWidth: 1,
                  minorTickInterval: "auto",
                  minorTickWidth: 1,
                  tickPosition: "outside",
                  tickWidth: 2,
                },
                {
                  // Tertiary yAxis
                  gridLineWidth: 0,
                  title: {
                    text: "Water Cummulatives(stb)",
                  },

                  opposite: true,
                  lineWidth: 1,
                  minorGridLineWidth: 1,
                  minorTickInterval: "auto",
                  minorTickWidth: 1,
                  tickPosition: "outside",
                  tickWidth: 2,
                },
              ],
              tooltip: {
                shared: true,
              },
              legend: {
                layout: "horizontal",
                align: "center",

                verticalAlign: "bottom",

                backgroundColor: "#FFFFFF",
              },
              series: [
                {
                  name: "OilDailyPrd",
                  type: "spline",
                  yAxis: 1,
                  data: getSeriesData("oilCum"),
                  tooltip: {
                    valueSuffix: " stb",
                  },
                  marker: {
                    enabled: false,
                  },
                  color: "red",
                },
                {
                  name: "Water",
                  type: "spline",
                  yAxis: 2,
                  data: getSeriesData("waterCum"),
                  marker: {
                    enabled: false,
                  },
                  color: "blue",
                  tooltip: {
                    valueSuffix: "stb",
                  },
                },

                {
                  name: "Gas ",
                  color: "green",
                  type: "spline",
                  data: getSeriesData("gasCum"),
                  tooltip: {
                    valueSuffix: " Mscf",
                  },
                  marker: {
                    enabled: false,
                  },
                },
              ],
            }}
          />
        );
      }}
    </Observer>
  );
};

